import React from "react";
import { formatDistanceToNow } from "date-fns";
import styles from "./bugInfo.module.scss";
const BugInfo = ({ bugInfo, bugType, }) => {
    if (!bugInfo.present) {
        return bugType === "resolved" ? React.createElement("span", null, "Not resolved") : null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            "Version ",
            bugInfo.version),
        bugInfo.timestamp && (React.createElement("div", { className: styles.timestamp, title: bugInfo.timestamp }, formatDistanceToNow(new Date(bugInfo.timestamp), {
            addSuffix: true,
        })))));
};
export default BugInfo;
//# sourceMappingURL=BugInfo.js.map